'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _events = require('../../../../../events');

var _events2 = _interopRequireDefault(_events);

var _registrations = require('../../../../../registrations');

var _registrations2 = _interopRequireDefault(_registrations);

var _prompt = require('../../../../../prompt');

var _prompt2 = _interopRequireDefault(_prompt);

var _feiseanna = require('../../../../../feiseanna');

var _feiseanna2 = _interopRequireDefault(_feiseanna);

var _payments = require('../../../../../payments');

var _payments2 = _interopRequireDefault(_payments);

var _participantSidenav = require('../../../../../participant-sidenav');

var _participantSidenav2 = _interopRequireDefault(_participantSidenav);

var _registrationsProductsSidenav = require('../../../../../registrations-products-sidenav');

var _registrationsProductsSidenav2 = _interopRequireDefault(_registrationsProductsSidenav);

var _cashCollectDialog = require('../../../../../cash-collect-dialog');

var _cashCollectDialog2 = _interopRequireDefault(_cashCollectDialog);

var _session = require('../../../../../session');

var _session2 = _interopRequireDefault(_session);

var _accounts = require('ifeis-isomorphic/lib/redux/actions/accounts');

var _stages = require('../../../../../../../isomorphic/lib/redux/actions/stages');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RegistrationController = function () {
  function RegistrationController($scope, fRegistrationService, fFeisService, feis, $mdSidenav, metadata, participant, $state, fSession, $ngRedux, msgService, $mdDialog, fAlert) {
    var _this = this;

    _classCallCheck(this, RegistrationController);

    _initialiseProps.call(this);

    this._ = { $ngRedux: $ngRedux, $mdSidenav: $mdSidenav, $state: $state, fFeisService: fFeisService, fRegistrationService: fRegistrationService, participant: participant, msgService: msgService, $mdDialog: $mdDialog, fAlert: fAlert };
    this.showPerson = !!participant;
    this.filter = '';
    this.clearBtn = false;
    this.page = 1;
    this.feis = feis;
    this.roles = metadata.grants;
    this.limit = 15;
    this.loading = 0;
    this.searchText = '';

    fSession.user().then(function (user) {
      _this.user = user;
    });

    this.getParticipants();

    $scope.$watch(function () {
      return _this._.$mdSidenav('registrations-products-sidenav').isOpen();
    }, function (open, history) {
      if (!open && history) {
        _this.currentPerson = null;
        _this._.participant = null;
      }
    });
  }

  _createClass(RegistrationController, [{
    key: 'toggleLeftNav',
    value: function toggleLeftNav() {
      this._.$mdSidenav('left').toggle();
    }
  }, {
    key: 'filterParticipants',
    value: function filterParticipants(event) {
      if (!event) this.searchFilter = '';

      this.clearBtn = !!this.searchFilter;
      this.filter = this.searchFilter;
      this.getParticipants();
    }
  }, {
    key: 'getParticipants',
    value: function getParticipants(page) {
      var _this2 = this;

      this.loading++;
      this.page = page || 1;

      return this._.fFeisService.prospects(this.feis.id, {
        offset: this.page * this.limit - this.limit,
        limit: this.limit,
        filter: this.filter,
        filter_fields: 'fname,lname,school'
      }).then(function (participants) {
        _this2.participants = participants.map(function (person) {
          person.$feisAge = _this2._.fRegistrationService.getFeisAge(_this2.feis, person);
          return person;
        });

        _this2.loading--;

        if (_this2._.participant) _this2.show(_this2._.participant);
      });
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.currentPerson = null;
      this._.$state.go('feiseanna.one.admin.registration', { participant: null }, { notify: false });
      this._.$mdSidenav('registrations-products-sidenav').close();
    }
  }, {
    key: 'next',
    value: function next() {
      if (this.participants.length === 0) {
        return;
      }

      this.getParticipants(this.page + 1);
    }
  }, {
    key: 'previous',
    value: function previous() {
      if (this.page <= 1) {
        return;
      }

      this.getParticipants(this.page - 1);
    }
  }, {
    key: 'show',
    value: function show(person) {
      this.currentPerson = person;
      this._.$mdSidenav('registrations-products-sidenav').open();
    }
  }, {
    key: 'search',
    value: function search(searchText) {
      return this._.$ngRedux.dispatch((0, _accounts.searchAccountsForText)(searchText, this.feis.id)).then(function (resp) {
        return resp.payload || [];
      });
    }
  }]);

  return RegistrationController;
}();

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.edit = function ($event) {
    var account = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var saved = arguments[2];
    var dancersRegistered = arguments[3];

    if (!account || account == {} || !account.fname) {
      return;
    } else {
      _this3.originalAccountObject = _extends({}, account, { saved: saved, dancersRegistered: dancersRegistered });
      if (!_this3.originalAccountObject.saved) {
        return _this3._.$ngRedux.dispatch((0, _accounts.attachFeis)(_this3.originalAccountObject.id, _this3.feis.id, true)).then(function () {
          _this3.searchText = '';
          _this3._.msgService.displaySuccessMsg('Account attached to feis successfully');
        });
      } else {
        if (_this3.originalAccountObject.dancersRegistered) {
          return _this3._.fAlert($event, 'Already registered.', 'Sorry, an Account cannot be \'unstarred\' once a registration has been made.');
        } else {
          return _this3._.$mdDialog.show({
            title: 'Remove Star Relationship for this Account?',
            event: $event,
            controller: function controller($scope, $q) {
              $scope.cancel = function () {
                _this3.searchText = '';
                _this3._.$mdDialog.cancel();
              };

              $scope.account = _extends({}, account);

              $scope.responseToClick = function () {
                _this3.searchText = '';
                _this3._.$mdDialog.hide();
              };
            },
            template: ['<md-dialog ng-class="class">', '<form novalidate name="form">', ' <md-toolbar>', ' <h2 class="md-toolbar-tools md-toolbar-tools-bottom" layout="row">Deregister?</h2>', ' </md-toolbar>', '  <md-content>', '    <md-subheader class="md-sticky-no-effect">Remove Star Relationship for this Account?</md-subheader>', '  </md-content>', '  <div class="md-actions" layout="row">', '    <md-button type="button" ng-click="cancel()" class="md-primary">No</md-button>', '    <md-button type="submit" ng-click="responseToClick()">Yes</md-button>', '  </div>', '  </form>', '</md-dialog>'].join("\n")
          }).then(function () {
            _this3.searchText = '';
            return _this3._.$ngRedux.dispatch((0, _accounts.detachFeis)(_this3.originalAccountObject.id, _this3.feis.id, true)).then(function (res) {
              if (res.errors && res.errors.data) {
                var errors = res.errors.data.errors;

                _this3._.msgService.displayErrorMsg(errors && errors.length > 0 && errors[0].detail || 'Unexpected error occurred');
              } else {
                _this3._.msgService.displaySuccessMsg('Account detached from feis');
              }
            }).catch(function (eResponse) {
              var error = eResponse.errors && eResponse.errors.data || eResponse.errors || {};
              _this3._.msgService.displayErrorMsg(error.errors && error.errors.length > 0 && error.errors[0].detail);
            });
          });
        }
      }
    }
  };
};

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.registration', ['ngMaterial', 'ui.router', 'ifeis.accounts', 'ifeis.prompt', 'ifeis.registrations', 'ifeis.feiseanna', 'ifeis.payments', 'ifeis.events', 'ifeis.registrations-products-sidenav', 'ifeis.participant-sidenav', 'ifeis.cash-collect-dialog', 'ifeis.router-history']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.registration', {
    controller: 'RegistrationController',
    controllerAs: 'registration',
    resolve: {
      participant: function participant($stateParams, fFeisService) {
        if (!$stateParams.participant) return;

        return fFeisService.prospect($stateParams.id, $stateParams.participant);
      }
    },
    template: require('./tpl.html'),
    url: '/registration/:participant',
    ncyBreadcrumb: {
      label: 'Registration',
      parent: 'feiseanna.one.admin.manager'
    }
  });
}).controller('RegistrationController', RegistrationController);


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/registration/index.js
// module id = 555
// module chunks = 0